import {bp} from './namespace.js';

$.extend(true, bp, {
  effects: (function () {
    return {
      shake: function (element) {
        var interval = 100;
        var distance = 10;
        var times = 4;

        $(element).css('position', 'relative');

        for (var iter = 0; iter < (times + 1); iter++) {
          $(element).animate({
            left: ((iter % 2 === 0 ? distance : distance * -1)),
          }, interval);
        }

        $(element).animate({left: 0}, interval);
      },
    };
  })(),
});

export {bp};
